/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Quote = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.70123 11.9613C8.10199 11.4608 7.60944 11.0493 7.60944 10.4206C7.60944 8.76577 8.71924 7.59186 9.54952 6.71361C10.0457 6.18876 10.4421 5.76951 10.4421 5.41631C10.4421 4.4721 9.21459 4 8.45923 4C5.62661 4 1 10.515 1 15.4249C1 18.2575 2.98283 20.9957 6.00429 20.9957C8.83691 20.9957 10.8197 18.9185 10.8197 16.0858C10.8197 13.731 9.63183 12.7387 8.70123 11.9613ZM20.8815 11.9613C20.2823 11.4608 19.7897 11.0493 19.7897 10.4206C19.7897 8.73339 20.9819 7.50764 21.8445 6.62064C22.3336 6.11777 22.7168 5.72378 22.7168 5.41631C22.7168 4.56652 21.3949 4 20.6395 4C17.8069 4 13.1803 10.515 13.1803 15.4249C13.1803 18.2575 15.1631 20.9957 18.1846 20.9957C21.0172 20.9957 23 18.9185 23 16.0858C23 13.731 21.8121 12.7387 20.8815 11.9613Z"
                        fill={color}
                    />
                </svg>
        );
    };
